import {fetch} from '../utils/fetch'
import {casaApiUrl} from 'configs/casa-api'
import queryString from 'query-string'
import moment from 'moment-timezone'

function getOrderCaptureForm () {
  return fetch(`${casaApiUrl}/users/form-fields/orderCaptureForm/latest`, {
    credentials: 'include',
    method: 'GET'
  }).then(res => res.json())
}

function getOrderCaptureByRefs (refs) {
  return fetch(`${casaApiUrl}/users/order-capture/raw/by?${refs}`, {
    credentials: 'include',
    method: 'GET'
  }).then(res => res.json())
}

function getOrderCaptureByDateRange (filter) {
  let {startDate, endDate, storeNames} = filter.toJSON()
  let startDateParam = moment(startDate).format('YYYY-MMM-DD')
  let endDateParam = moment(endDate).format('YYYY-MMM-DD')
  let query = queryString.stringify({
    stores: storeNames,
    startDate: startDateParam,
    endDate: endDateParam
  }, {arrayFormat: 'bracket'})
  return fetch(`${casaApiUrl}/users/order-capture/filter?${query}`, {
    credentials: 'include',
    method: 'GET'
  }).then(res => res.json())
}

function getUserDetails () {
  const searchParams = new URLSearchParams(location.search);
  const isUserSpecific =
    (searchParams.has("token") && searchParams.has("loadTokenFromUrl")) ||
    false;
  let baseUrl = `${casaApiUrl}/users`;
  if (isUserSpecific) baseUrl += "?userSpecific=true";
  return fetch(baseUrl, {
    credentials: 'include',
    method: 'GET'
  }).then(res => res.json())
}

export default {
  getOrderCaptureForm,
  getOrderCaptureByRefs,
  getOrderCaptureByDateRange,
  getUserDetails
}



// WEBPACK FOOTER //
// ./src/services/order-capture-service.js